/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Acciones',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Enviar opiniones',
  'ai-smart-button.ai-actions.help.section.text': 'Ayuda',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Enlace',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Mención',
  'ai-smart-button.ai-actions.input.send-button-label': 'Enviar',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOVEDAD',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Añadir icono',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Icono de automatización',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatizaciones',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Buscar agentes',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Crear automatización',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Estudio',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Hola, {name}:',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Descartar',
  'ai-smart-button.feedback-action.ask-question-option': 'Plantear una pregunta',
  'ai-smart-button.feedback-action.cancel-button-label': 'Cancelar',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Elegir uno',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Describe el error o la incidencia',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Cuéntanos qué piensas',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': '¿Qué te gustaría saber?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dinos qué te gustaría mejorar',
  'ai-smart-button.feedback-action.feedback-modal-heading': 'Danos tu opinión',
  'ai-smart-button.feedback-action.leave-comment-option': 'Dejar un comentario',
  'ai-smart-button.feedback-action.report-bug-option': 'Informar de un error',
  'ai-smart-button.feedback-action.research-participation-message':
    'Me gustaría participar en la investigación de productos',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Seleccionar comentarios',
  'ai-smart-button.feedback-action.submit-button-label': 'Enviar comentarios',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Sugerir una mejora',
  'ai-smart-button.feedback-action.title': 'Enviar opiniones',
  'ai-smart-button.feedback-item.icon-label': 'Icono de feedback',
  'ai-smart-button.reference.close-button-label': 'Cerrar',
};
